const bessReducer = (
  state = { overview: { systems: [], loading: true }, details: {} },
  action
) => {
  switch (action.type) {
    case 'SET_SYSTEMS': {
      return {
        ...state,
        overview: { systems: action.payload, loading: false }
      };
    }
    case 'SET_SYSTEM_DETAILS': {
      const { system, systemId } = action.payload;

      return {
        ...state,
        details: { ...state.details, [systemId]: system }
      };
    }
    case 'SET_SYSTEMS_LOADING': {
      return { ...state, overview: { ...state.overview, loading: true } };
    }
    default:
      return state;
  }
};

export default bessReducer;
